export enum JustifyValues {
  Center = 'center',
  Start = 'start',
  End = 'end'
}

export interface ButtonCardProps {
  // Controlled value
  isSelected?: boolean
  disabled?: boolean
  // Initial value
  initialSelected?: boolean
  className?: string
  onClick?: (e: React.MouseEvent | React.KeyboardEvent) => void
  children?: React.ReactNode
}

export interface ButtonContentProps {
  logo?: React.ReactNode
  title?: React.ReactNode
  description?: React.ReactNode
  cover?: React.ReactNode
  justify?: `${JustifyValues}`
  contentStyle?: Record<string, unknown>
  // If this prop is sent we will overwrite the
  // button card content and use the children instead
  children?: React.ReactNode
}

export interface CheckboxButtonContentProps extends ButtonContentProps {
  isSelected: boolean
}
